import React from 'react';
import PropTypes from 'prop-types';
import { Helmet } from 'react-helmet';
import { Row, Col, Button } from 'react-bootstrap';
import { connect as reduxConnect } from '../../reducers/index';
import Navigation from '../../components/Navigation';
import Footer from '../../components/Footer';
import TextHero from '../../components/TextBanner';
import ServicesGrid from '../../components/ServiceGrid';
import './styles.css';
import ResourcesContent from './constant';

class ResourcesPage extends React.Component {
  constructor(props) {
    super(props);
    this.state = { role: localStorage.getItem('role') || 'NONE' };
  }

  printClicked = () => {
    window.print();
  };

  render() {
    const { role } = this.props;
    const { roleType, campusType } = role;

    let title;
    let studentResources = {
      StudentResources: ResourcesContent.StudentResources,
      CommunityResources: ResourcesContent.CommunityResources,
      EmergencyResources: ResourcesContent.EmergencyResources,
      AppResources: ResourcesContent.AppResources,
      StudentResourcesOther: ResourcesContent.StudentResourcesOther,
      EmergencyResourcesOther: ResourcesContent.EmergencyResourcesOther
    };
    let nonStudentResources = {
      StudentResourcesStaff: ResourcesContent.StudentResourcesStaff,
      CampusAll: ResourcesContent.CampusAll,
      StaffResources: ResourcesContent.StaffResources,
      CommunityResources: ResourcesContent.CommunityResources,
      EmergencyResources: ResourcesContent.EmergencyResources,
      AppResources: ResourcesContent.AppResources,
      StudentResourcesOther: ResourcesContent.StudentResourcesOther,
      EmergencyResourcesOther: ResourcesContent.EmergencyResourcesOther
    };

    if (roleType === 'FACULTY' && campusType === 'UTSG') {
      title = 'Resources for UTSG Staff & Faculty';
    } else if (roleType === 'STAFF' && campusType === 'UTSG') {
      title = 'Resources for UTSG Staff & Faculty';
    } else if (
      (roleType === 'STUDENT' && campusType === 'UTSG') ||
      (roleType === 'OTHER' && campusType === 'UTSG')
    ) {
      title = 'Resources for UTSG Students';
    } else if (roleType === 'FACULTY' && campusType === 'UTSC') {
      title = 'Resources for UTSC Staff & Faculty';
      nonStudentResources = {
        StudentResourcesStaff: ResourcesContent.StudentResourcesStaffUTSC,
        CampusAll: ResourcesContent.CampusAllUTSC,
        StaffResources: ResourcesContent.StaffResourcesUTSC,
        CommunityResources: ResourcesContent.CommunityResourcesUTSC,
        EmergencyResources: ResourcesContent.EmergencyResourcesUTSC,
        AppResources: ResourcesContent.AppResourcesUTSC
      };
    } else if (roleType === 'STAFF' && campusType === 'UTSC') {
      title = 'Resources for UTSC Staff & Faculty';
      nonStudentResources = {
        StudentResourcesStaff: ResourcesContent.StudentResourcesStaffUTSC,
        CampusAll: ResourcesContent.CampusAllUTSC,
        StaffResources: ResourcesContent.StaffResourcesUTSC,
        CommunityResources: ResourcesContent.CommunityResourcesUTSC,
        EmergencyResources: ResourcesContent.EmergencyResourcesUTSC,
        AppResources: ResourcesContent.AppResourcesUTSC
      };
    } else if (
      (roleType === 'STUDENT' && campusType === 'UTSC') ||
      (roleType === 'OTHER' && campusType === 'UTSC')
    ) {
      title = 'Resources for UTSC Students';
      studentResources = {
        StudentResources: ResourcesContent.StudentResourcesUTSC,
        CommunityResources: ResourcesContent.CommunityResourcesUTSC,
        EmergencyResources: ResourcesContent.EmergencyResourcesUTSC,
        AppResources: ResourcesContent.AppResourcesUTSC
      };
    } else if (roleType === 'FACULTY' && campusType === 'UTM') {
      title = 'Resources for UTM Staff & Faculty';
      nonStudentResources = {
        StudentResourcesStaff: ResourcesContent.StudentResourcesStaffUTM,
        CampusAll: ResourcesContent.CampusAllUTM,
        StaffResources: ResourcesContent.StaffResourcesUTM,
        CommunityResources: ResourcesContent.CommunityResourcesUTM,
        EmergencyResources: ResourcesContent.EmergencyResourcesUTM,
        AppResources: ResourcesContent.AppResourcesUTM
      };
    } else if (roleType === 'STAFF' && campusType === 'UTM') {
      title = 'Resources for UTM Staff & Faculty';
      nonStudentResources = {
        StudentResourcesStaff: ResourcesContent.StudentResourcesStaffUTM,
        CampusAll: ResourcesContent.CampusAllUTM,
        StaffResources: ResourcesContent.StaffResourcesUTM,
        CommunityResources: ResourcesContent.CommunityResourcesUTM,
        EmergencyResources: ResourcesContent.EmergencyResourcesUTM,
        AppResources: ResourcesContent.AppResourcesUTM
      };
    } else if (
      (roleType === 'STUDENT' && campusType === 'UTM') ||
      (roleType === 'OTHER' && campusType === 'UTM')
    ) {
      title = 'Resources for UTM Students';
      studentResources = {
        StudentResources: ResourcesContent.StudentResourcesUTM,
        CommunityResources: ResourcesContent.CommunityResourcesUTMStudent,
        EmergencyResources: ResourcesContent.EmergencyResourcesUTM,
        AppResources: ResourcesContent.AppResourcesUTM
      };
    } else if (
      campusType === 'OTHER'
    ) {
      title = 'Resources for Other';
      studentResources = {
        StudentResources: ResourcesContent.StudentResources,
        CommunityResources: ResourcesContent.CommunityResources,
        EmergencyResources: ResourcesContent.EmergencyResources,
        AppResources: ResourcesContent.AppResources,
        StudentResourcesOther: ResourcesContent.StudentResourcesOther,
        EmergencyResourcesOther: ResourcesContent.EmergencyResourcesOther
      };
      nonStudentResources = {
        StudentResourcesStaff: ResourcesContent.StudentResourcesStaff,
        CampusAll: ResourcesContent.CampusAll,
        StaffResources: ResourcesContent.StaffResources,
        CommunityResources: ResourcesContent.CommunityResources,
        EmergencyResources: ResourcesContent.EmergencyResources,
        AppResources: ResourcesContent.AppResources,
        StudentResourcesOther: ResourcesContent.StudentResourcesOther,
        EmergencyResourcesOther: ResourcesContent.EmergencyResourcesOther
      };
    }

    const displayNone = { display: "none" };
    const displayBlock = { display: "block" };

    return (
      <div className="resources">
        <Helmet>
          <title>Resources</title>
        </Helmet>
        <Navigation role={role} />
        <TextHero
          childTitle={title}
          rightChildTitle={'In case of emergency'}
          rightChildContent={'call 911'}
        />

        <Row className="text-center">
          <Col className="buttonCol" xs={12} sm={1} smOffset={9}>
            <Button className="buttonPrint" onClick={this.printClicked}>
              Print Resources
            </Button>
          </Col>
        </Row>

        <section className="no-padd">
          {roleType === 'STUDENT' || roleType === 'OTHER' ? (
            <div>
              <Row>
                <Col md={10} mdOffset={1}>
                  <h2 className="text-center txt-dkblue">
                    Campus Resources for Students
                  </h2>
                  <ServicesGrid resources={
                    campusType === "OTHER" ?
                      studentResources.StudentResourcesOther :
                      studentResources.StudentResources
                  } />
                </Col>
              </Row>
              <Row style={campusType === "OTHER" ? displayNone : displayBlock}>
                <Col xs={10} xsOffset={1}>
                  <h2 className="text-center txt-dkblue">
                    Community Resources for Students, Staff and Faculty
                  </h2>
                  <ServicesGrid
                    resources={studentResources.CommunityResources}
                  />
                </Col>
              </Row>
              <Row>
                <Col xs={10} xsOffset={1}>
                  <h2 className="text-center txt-dkblue">
                    Emergency Resources
                  </h2>
		  {/*
                  <p className="text-center">
                    When supporting someone with intentions to harm themselves
                    or others, call one of these emergency resources:
                  </p>
		  */}
                  <ServicesGrid resources={
                    campusType === "OTHER" ?
                      studentResources.EmergencyResourcesOther :
                      studentResources.EmergencyResources
                  } />
                </Col>
              </Row>
              <Row style={campusType === "OTHER" ? displayNone : displayBlock}>
                <Col xs={10} xsOffset={1}>
                  <h2 className="text-center txt-dkblue">App Resources</h2>
                  <ServicesGrid
                    //resources={ResourcesContent.CommunityResources}
                    resources={studentResources.AppResources}
                  />
                </Col>
              </Row>
            </div>
          ) : (
              <div>
                <Row>
                  <Col xs={10} xsOffset={1}>
                    <h2 className="text-center txt-dkblue">
                      Campus Resources for Students
                  </h2>
                    <ServicesGrid resources={
                      campusType === "OTHER" ?
                        nonStudentResources.StudentResourcesOther :
                        nonStudentResources.StudentResourcesStaff
                    } />
                  </Col>
                </Row>
                <Row style={campusType === "OTHER" ? displayNone : displayBlock}>
                  <Col xs={10} xsOffset={1}>
                    <h2 className="text-center txt-dkblue">
                      Campus Resources for Students, Staff and Faculty
                  </h2>
                    <ServicesGrid
                      // resources={ResourcesContent.CampusAll}
                      resources={nonStudentResources.CampusAll}
                    />
                  </Col>
                </Row>
                <Row style={campusType === "OTHER" ? displayNone : displayBlock}>
                  <Col xs={10} xsOffset={1}>
                    <h2 className="text-center txt-dkblue">
                      Campus Resources for Staff and Faculty
                  </h2>
                    <ServicesGrid
                      // resources={ResourcesContent.StaffResources}
                      resources={nonStudentResources.StaffResources}
                    />
                  </Col>
                </Row>
                <Row style={campusType === "OTHER" ? displayNone : displayBlock}>
                  <Col xs={10} xsOffset={1}>
                    <h2 className="text-center txt-dkblue">
                      Community Resources for Students, Staff and Faculty
                  </h2>
                    <ServicesGrid
                      //resources={ResourcesContent.CommunityResources}
                      resources={nonStudentResources.CommunityResources}
                    />
                  </Col>
                </Row>
                <Row>
                  <Col xs={10} xsOffset={1}>
                    <h2 className="text-center txt-dkblue">
                      Emergency Resources
                  </h2>
		   {/*
                    <p className="text-center">
                      When supporting someone with intentions to harm themselves
                      or others, call one of these emergency resources:
                  </p>
		    */}
                    <ServicesGrid resources={
                      campusType === "OTHER" ?
                        nonStudentResources.EmergencyResourcesOther :
                        nonStudentResources.EmergencyResources
                    } />
                    <p>&nbsp;</p>
                  </Col>
                </Row>
                <Row style={campusType === "OTHER" ? displayNone : displayBlock}>
                  <Col xs={10} xsOffset={1}>
                    <h2 className="text-center txt-dkblue">App Resources</h2>
                    <ServicesGrid
                      //resources={ResourcesContent.CommunityResources}
                      resources={nonStudentResources.AppResources}
                    />
                  </Col>
                </Row>
              </div>
            )}
        </section>
        <Footer />
      </div>
    );
  }
}

ResourcesPage.propTypes = {
  role: PropTypes.object.isRequired // eslint-disable-line react/forbid-prop-types
};

ResourcesPage.defaultProps = {
  role: {}
};

const Resources = ResourcesPage;

export default reduxConnect.role(Resources);



// WEBPACK FOOTER //
// ./src/containers/Resources/index.jsx